import React from "react";
import Layout from "../../components/Layout/Layout";
import Feedback from "../../components/general/Feedback/Feedback";
import { useProducts } from "../../hooks/useProducts";
import { IProduct } from "../../models/IProduct";

const TestPage: React.FC = () => {
  const { data, isLoading, isError } = useProducts(true);
  const [products, setProducts] = React.useState<IProduct[]>([]);

  React.useEffect(() => {
    if (data) {
      setProducts(data);
    }
  }, [data]);


  return (
    <Layout>
      {products.map((item) => (
        <React.Fragment key={item.id}>
          {item.image_data ? <img src={`data:image/webp;base64,${item.image_data}`} alt={item.name} /> : null}
        </React.Fragment>
      ))}
      <Feedback />
    </Layout>
  );
};

export default TestPage;
